// ShowFolderPicker .js                   показ папок для завантаження файлів 

import React from 'react';
import PropTypes from 'prop-types';
import CreateFolderInline from './CreateFolderInline';

export default function ShowFolderPicker({ uploadLb }) {

    if (!uploadLb.showFolderPicker) return null;

    return (
        <>
            <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
                <div className="bg-white rounded-xl shadow-xl w-full max-w-xl">
                    <div className="p-4 border-b flex items-center justify-between">
                        <div className="font-semibold">Вибір папки</div>
                        <button className="text-sm px-2 py-1 border rounded" onClick={() => uploadLb.setShowFolderPicker(false)}>✕</button>
                    </div>
                    <div className="p-4">
                        <div className="flex items-center gap-2 mb-3">
                            <button className="px-2 py-1 border rounded" onClick={uploadLb.goUp} disabled={uploadLb.path.length <= 1}>↑ Вгору</button>
                            <div className="text-sm text-gray-600 truncate">
                                {uploadLb.path.map(f => f.name).join(' / ')}
                            </div>
                        </div>
                        <ul className="divide-y max-h-80 overflow-auto">
                            {uploadLb.folders.map(f => (
                                <li key={f.id} className="py-2 flex items-center justify-between">
                                    <button className="text-left flex-1 hover:underline" onClick={() => uploadLb.enterFolder(f)}>
                                        <span>{(f.isShortcutFolder ? '🔗' : '') + '📁 ' + f.name}</span>
                                    </button>
                                    <span className="text-xs text-gray-500">{f.modifiedTime?.slice(0, 10)}</span>
                                </li>
                            ))}
                            {uploadLb.folders.length === 0 && <li className="py-6 text-center text-sm text-gray-500">Порожньо</li>}
                        </ul>
                        <div className="mt-4 flex items-center gap-2">
                            <CreateFolderInline onCreate={uploadLb.createFolder} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
ShowFolderPicker.propTypes = {
    uploadLb: PropTypes.object.isRequired,
};

